import { isValidInput as validateInput } from '@/utils';

export const isValidInput = (value?: string) =>
  validateInput(value?.trim() || '') || 'Invalid input';

export const createRequiredValidator = (message: string) => (value?: string) =>
  !!value?.length || message;
export const createMaxLengthValidator =
  (maxLength: number) => (value?: string) =>
    (value?.length ?? 0) <= maxLength ||
    `Maximum ${maxLength} chars are allowed`;
